import React, { useEffect } from "react";
import AboutUs from "../../components/Replica/AboutUs";
import ReplicaBanners from "../../components/Replica/Banner";
import ChooseUs from "../../components/Replica/ChooseUs";
import ContactUs from "../../components/Replica/ContactUs";
import CustomCount from "../../components/Replica/CustomCounts";
import Enquiry from "../../components/Replica/Enquiry";
import Features from "../../components/Replica/Features";
import Services from "../../components/Replica/Services";
import { ApiHook } from "../../hooks/apiHook";
import PageTitle from "../../components/Common/PageTitle";

const MainReplica = () => {
  const replica = ApiHook.CallReplicaHome();
  console.log(replica?.data?.data?.replicaOwner?.id, "replica");

  const setCookie = (name, value, hours) => {
    const date = new Date();
    date.setTime(date.getTime() + hours * 60 * 60 * 1000); // Convert hours to milliseconds
    const expires = `expires=${date.toUTCString()}`;
    document.cookie = `${name}=${value}; ${expires}; path=/`;
  };

  useEffect(() => {
    if (
      replica?.data?.data?.cookieLife &&
      replica?.data?.data?.replicaOwner?.id
    ) {
      const cookieLife = replica.data.data.cookieLife;
      const sponsorId = replica.data.data.replicaOwner.id;
      setCookie("sponsorId", sponsorId, cookieLife);
      console.log(
        `Cookie 'sponsorId' set with value ${sponsorId} for ${cookieLife} hours`
      );
    }
  }, [replica?.data?.data?.cookieLife, replica?.data?.data?.replicaOwner?.id]);

  if (replica.isLoading) {
    return (
      <div className="theme-loader">
        <div className="spinner">
          <div className="spinner-bounce one"></div>
          <div className="spinner-bounce two"></div>
          <div className="spinner-bounce three"></div>
        </div>
      </div>
    );
  }

  return (
    <>
      <PageTitle title={"User | Replica Home"} />
      <ReplicaBanners data={replica?.data?.data?.replicaHome?.replicaBanners} />
      <Features data={replica?.data?.data?.replicaHome?.features} />
      <AboutUs data={replica?.data?.data?.replicaHome?.aboutUs} />
      <Services data={replica?.data?.data?.replicaHome?.services} />
      {/* <CustomCount /> */}
      <ChooseUs data={replica?.data?.data?.replicaHome?.chooseUs} />
      <Enquiry />
      <ContactUs companyDetails={replica?.data?.data?.companyDetails} />
    </>
  );
};

export default MainReplica;
